import { pList, rSorgulamaSonuclari } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import rList from '../../../../api/models/rList';


export const action_async_start = (body: pList): IPromiseAction<pList> =>
    ActionFunctions.action_async_start_promise(
        ActionSubTypes.API_TIKLAMASONUCLARILISTE,
        new Api.Bilgi.TiklamaSonuclariListe().Request(body),
        false,
        false,
        body
    );

export const action_async_complete = (
    data: rList<rSorgulamaSonuclari> | null | undefined,
    error: IError | null | undefined
): IApiAction<rSorgulamaSonuclari[]> =>
    ActionFunctions.action_async_complete_api<rSorgulamaSonuclari[]>(
        ActionSubTypes.API_TIKLAMASONUCLARILISTE,
        data?.Values,
        error
    );
